import apis from "@/apis";
export default {
  namespaced: true,
  state: {
    data: [],
    lasttime: 0,
  },
  actions: {
    fetch(context) {
      return apis.getThirdPartys().then((response) => {
        context.commit("update", response.data);
        context.lasttime = Date.now();
        return Promise.resolve(response);
      });
    },
  },
  mutations: {
    update(state, data) {
      state.data = data;
      state.hasLoaded = true;
    }
  },
  getters: {
    data(state) {
      return (key) => {
        return state.record[key];
      };
    },
  },
};
